(() => {
  const selector = 'product-price .price';
  const style = document.createElement('style');
  style.textContent = `
    product-price .price.etg-eur-only > .money {
      display: none !important;
    }
    product-price .price.etg-eur-only {
      gap: 0 !important;
    }
  `;
  document.head.append(style);

  function selectedCurrency() {
    const switcher = document.querySelector('.currency-switcher');
    return switcher?.innerText.match(/\b[A-Z]{3}\b/)?.[0] || 'EUR';
  }

  function update() {
    const eur = selectedCurrency() === 'EUR';

    document.querySelectorAll(selector).forEach(container => {
      const money = container.querySelector(':scope > .money');
      const original = container.querySelector(':scope > .original-price');
      if (!money || !original) return;

      const clean = original.textContent.trim().replace(/^\(/, '').replace(/\)$/, '');
      if (original.textContent !== clean) original.textContent = clean;

      container.classList.toggle('etg-eur-only', eur);
      container.classList.remove('etg-usd-only');
    });
  }

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();
